import React, { Component } from 'react';
import { connect } from 'react-redux';

import SVG from 'components/base/SVG';

import PropertyGallery from '../Gallery/Gallery';
import css from './style.scss';


class GalleryCellRenderer extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(ev) {
    const { openPropertyGallery, context, data: { id, propertyId } } = this.props;

    ev.stopPropagation();

    if (context && context.hackHandleIgnoreNextRowClick) context.hackHandleIgnoreNextRowClick(); // Above isn't being honored.

    // Grids inside Property Details (e.g. Linked Properties) expose its props
    // through `getSurroundingProps`, including any raised `zIndex` — forward it
    // so the gallery stacks above Property Details (ATAI-503).
    const parentZIndex = context && context.getSurroundingProps ? context.getSurroundingProps().zIndex : undefined;

    openPropertyGallery({ id: propertyId || id, parentZIndex });
  }

  render() {
    const { value } = this.props;
    // remove no_photo with house-img-not-available
    return !value || value.includes('photo_coming_soon') || value.includes('house-img-not-available') ? null : <SVG icon="iconCamera" className={css.camera} onClick={this.handleClick} />;
  }
}

export default connect(null, { openPropertyGallery: PropertyGallery.open })(GalleryCellRenderer);
